import { createContext } from 'react';

import { MintelTracking } from '../types';

export default createContext<MintelTracking | undefined>(undefined);
